import { render, staticRenderFns } from "./v-pop-add.vue?vue&type=template&id=d5325760"
import script from "./v-pop-add.vue?vue&type=script&lang=js"
export * from "./v-pop-add.vue?vue&type=script&lang=js"
import style0 from "./v-pop-add.vue?vue&type=style&index=0&id=d5325760&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports